import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../services/firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUsuario(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);
  /*
    const login = (email, password) => {
      return signInWithEmailAndPassword(auth, email, password);
    };
    */
  /*const login = async (email, password) => {
    const cred = await signInWithEmailAndPassword(auth, email, password);
    const uid = cred.user.uid;

    // Buscar documento del alumno
    const ref = doc(db, "Users", uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      throw new Error("No existe el documento del alumno.");
    }

    const alumno = snap.data();

    if (!alumno["16 PagosWeb"]) {
      throw new Error("La cuenta no tiene vigencia.");
    }

    // Si vigencia es una fecha, validar contra la fecha actual
    const pagosWeb = alumno["16 PagosWeb"];
    if (typeof alumno["16 PagosWeb"] === "string") {
      const [dia, mes, anio] = pagosWeb.split("/");
      const fechaVigencia = new Date(`${anio}-${mes}-${dia}`);

      if (isNaN(fechaVigencia.getTime())) {
        throw new Error("Formato de fecha inválido en PagosWeb.");
      }
      const hoy = new Date();
      if (fechaVigencia < hoy) {
        throw new Error("La cuenta está expirada. Consulte a un administrador para obtener ayuda");
      }
    }

    return cred.user;
  };*/

  const login = async (email, password) => {
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const uid = cred.user.uid;

      // Buscar documento del alumno
      const ref = doc(db, "Users", uid);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        throw new Error("No existe el documento del alumno.");
      }

      const alumno = snap.data();

      if (!alumno["16 PagosWeb"]) {
        throw new Error("La cuenta no tiene vigencia.");
      }

      // Validar fecha de vigencia
      const pagosWeb = alumno["16 PagosWeb"];
      if (typeof pagosWeb === "string") {
        const [dia, mes, anio] = pagosWeb.split("/");
        const fechaVigencia = new Date(`${anio}-${mes}-${dia}`);

        if (isNaN(fechaVigencia.getTime())) {
          throw new Error("Formato de fecha inválido en PagosWeb.");
        }

        const hoy = new Date();
        if (fechaVigencia < hoy) {
          throw new Error(
            `La cuenta está expirada. Consulte a un administrador para obtener ayuda.`
          );
        }
      }

      return cred.user;
    } catch (error) {
      // Personalizar errores de Firebase Auth
      if (error.code === "auth/user-not-found" || error.code === "auth/wrong-password") {
        throw new Error("Datos de acceso erróneos, verifique e intente nuevamente.");
      }

      if (error.code === "auth/invalid-email") {
        throw new Error("El formato del correo es inválido.");
      }

      throw error;
    }
  };

  const logout = () => {
    return signOut(auth);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
